(function ($) {
	$(function () {
		$('body').on('click', '.cl_window', function(ev) {
			ev.preventDefault();
			$('body').css({
				overflow: 'hidden',
				// 'padding-right': '17px'
			});
			var id = $(this).attr('href');
			$(id).css({
				left: '100%'
			});
			$(id).show();
			$(id).animate({
				left: '0',
			}, 600, function() {
				$('.w_search input').focus();
			});
		});

		app.dom.$window.on('load', function() {
			var $alertBox = $('.alertBox');

			if (getCookie('visited')) {
			} else {
				$alertBox.css({
					left: '0'
				});
				setCookie('visited');
			}
		});

		$('.goodsCart__button').on('click', function(ev) {
			ev.preventDefault();
			$('body').css({
				overflow: 'hidden',
				// 'padding-right': '17px'
			});
			var id = $('#window_form');
			$(id).css({
				left: '100%'
			});
			$(id).show();
			$(id).animate({
				left: '0',
			}, 600, function() {
				$('.w_search input').focus();
			});
		});


		$('body').on('click', '.close_button', function(ev) {
			$('body').css({
				'overflow': 'auto',
				// 'padding-right': '0'
			});
			var wnd = $(this).parent().parent();
			$(wnd).animate({
				left: '-100%',
			}, 600, function() {
				$(wnd).hide();
			});
		});

		app.dom.$window.on('load', function() {
			var $mainBg = $('.header_bg');

			if (typeof videoEl != 'undefined') {
				var $video = $('<video />').attr(videoEl.attr);

				$.each(videoEl.sources, function(index, el) {
					$video.append('<source />').find('source:last').attr(el);
				});
				$mainBg.prepend($video);
				$video.bgSiazeCover({
					onPlayReady: function () {
						app.dom.$page.addClass('coverHide');
					}
				});
			}
		});
		// if ($('.videoBg').length) $('.videoBg').bgSiazeCover();

		var $select = $('.form_city').find('select');
		$select.selectric();
	});
})(jQuery);
